export default "__VITE_ASSET__UZJFsAdv__"